export const productActionTypes = {
  CREATE_PRODUCT: '@product/CREATE_PRODUCT',
  CREATE_PRODUCT_START: '@product/CREATE_PRODUCT_START',
  CREATE_PRODUCT_ERROR: '@product/CREATE_PRODUCT_ERROR',

  GET_PRODUCT_DRAFT: '@product/GET_PRODUCT_DRAFT',
  GET_PRODUCT_DRAFT_START: '@product/GET_PRODUCT_DRAFT_START',
  GET_PRODUCT_DRAFT_ERROR: '@product/GET_PRODUCT_DRAFT_ERROR',

  CHANGE_PRODUCT_DRAFT: '@product/CHANGE_PRODUCT_DRAFT',
  CHANGE_PRODUCT_DRAFT_START: '@product/CHANGE_PRODUCT_DRAFT_START',
  CHANGE_PRODUCT_DRAFT_ERROR: '@product/CHANGE_PRODUCT_DRAFT_ERROR',
  CHANGE_PRODUCT_DRAFT_VALIDATION_ERROR:
    '@product/CHANGE_PRODUCT_DRAFT_VALIDATION_ERROR',

  UPDATE_PRODUCT_DRAFT: '@product/UPDATE_PRODUCT_DRAFT',
  UPDATE_PRODUCT_DRAFT_START: '@product/UPDATE_PRODUCT_DRAFT_START',
  UPDATE_PRODUCT_DRAFT_ERROR: '@product/UPDATE_PRODUCT_DRAFT_ERROR',

  CHANGE_PRODUCT: '@product/CHANGE_PRODUCT',
  CHANGE_PRODUCT_START: '@product/CHANGE_PRODUCT_START',
  CHANGE_PRODUCT_ERROR: '@product/CHANGE_PRODUCT_ERROR',
  CHANGE_PRODUCT_VALIDATION_ERROR: '@product/CHANGE_PRODUCT_VALIDATION_ERROR',

  UPDATE_FIX_PRODUCT: '@product/UPDATE_FIX_PRODUCT',
  UPDATE_FLEX_PRODUCT: '@product/UPDATE_FLEX_PRODUCT',
  UPDATE_PRODUCT_START: '@product/UPDATE_PRODUCT_START',
  UPDATE_PRODUCT_ERROR: '@product/UPDATE_PRODUCT_ERROR',

  GET_ALL_PRODUCT_CATEGORIES: '@product/GET_ALL_PRODUCT_CATEGORIES',
  GET_ALL_PRODUCT_CATEGORIES_START: '@product/GET_ALL_PRODUCT_CATEGORIES_START',
  GET_ALL_PRODUCT_CATEGORIES_ERROR: '@product/GET_ALL_PRODUCT_CATEGORIES_ERROR',

  PUBLISH_PRODUCT_DRAFT: '@product/PUBLISH_PRODUCT_DRAFT',
  PUBLISH_PRODUCT_DRAFT_START: '@product/PUBLISH_PRODUCT_DRAFT_START',
  PUBLISH_PRODUCT_DRAFT_ERROR: '@product/PUBLISH_PRODUCT_DRAFT_ERROR',

  ADD_PRODUCT_DRAFT_ROWS: '@product/ADD_PRODUCT_DRAFT_ROWS',
  ADD_PRODUCT_DRAFT_ROWS_START: '@product/ADD_PRODUCT_DRAFT_ROWS_START',
  ADD_PRODUCT_DRAFT_ROWS_ERROR: '@product/ADD_PRODUCT_DRAFT_ROWS_ERROR',

  GET_ALL_FLEX_PRODUCTS: '@product/GET_ALL_FLEX_PRODUCTS',
  GET_ALL_FLEX_PRODUCTS_START: '@product/GET_ALL_FLEX_PRODUCTS_START',
  GET_ALL_FLEX_PRODUCTS_ERROR: '@product/GET_ALL_FLEX_PRODUCTS_ERROR',

  GET_ALL_FIX_PRODUCTS: '@product/GET_ALL_FIX_PRODUCTS',
  GET_ALL_FIX_PRODUCTS_START: '@product/GET_ALL_FIX_PRODUCTS_START',
  GET_ALL_FIX_PRODUCTS_ERROR: '@product/GET_ALL_FIX_PRODUCTS_ERROR',

  GET_FIX_PRODUCTS_BY_SEARCH: '@product/GET_FIX_PRODUCTS_BY_SEARCH',
  GET_FLEX_PRODUCTS_BY_SEARCH: '@product/GET_FLEX_PRODUCTS_BY_SEARCH',
  GET_PRODUCTS_BY_SEARCH_START: '@product/GET_PRODUCTS_BY_SEARCH_START',
  GET_PRODUCTS_BY_SEARCH_ERROR: '@product/GET_PRODUCTS_BY_SEARCH_ERROR',

  GET_PRODUCT_IS_DRAFT_EXISTS: '@product/GET_PRODUCT_IS_DRAFT_EXISTS',
  GET_PRODUCT_IS_DRAFT_EXISTS_START:
    '@product/GET_PRODUCT_IS_DRAFT_EXISTS_START',
  GET_PRODUCT_IS_DRAFT_EXISTS_ERROR:
    '@product/GET_PRODUCT_IS_DRAFT_EXISTS_ERROR',
};
